import EpiComponent from '@episerver/spa-core/EpiComponent';
import React, { ReactNode, ReactNodeArray } from 'react';
import CollectionPoints from './CollectionPoints';
import CollectionPointsBlockData from '../../../Models/Content/CollectionPointsBlockData';

export default class CollectionPointsBlock extends EpiComponent<CollectionPointsBlockData> {
  constructor(props) {
    super(props);
  }

  public render(): ReactNode | ReactNodeArray | null {
    return <CollectionPoints context={this.getContext()} iContent={this.props.data} />;
  }

}
